import Select from 'react-select';

import { selectStyle } from '../ReactSelect/styles';
import { Container } from './styles';

export interface IOptions {
  id: number | string;
  value: string;
}

interface IProps {
  placeholder?: string;
  options: Array<IOptions>;
  setValue: (value: string) => void;
  sizeDisplay?: 'lg' | 'md' | 'sm';
  value?: string | number;
  disabled?: boolean;
}

// Wrapper sobre react-select que preserva a API antiga (options {id,value} + setValue(id)).
// Substituiu o <select> nativo p/ controlar o estilo das options (nativo nao e estilizavel no Chrome/Windows).
const StyledSelect = ({
  options,
  placeholder,
  setValue,
  sizeDisplay = 'lg',
  value,
  disabled = false,
}: IProps) => {
  const selectOptions = options?.map((option) => ({
    value: String(option.id),
    label: option.value,
  }));

  const selected =
    selectOptions?.find((option) => option.value === String(value)) ?? null;

  return (
    <Container sizeDisplay={sizeDisplay}>
      <Select
        options={selectOptions}
        value={selected}
        onChange={(option) => setValue(option ? option.value : '')}
        placeholder={placeholder ?? ''}
        isSearchable={false}
        isDisabled={disabled}
        styles={selectStyle}
        menuPortalTarget={
          typeof document !== 'undefined' ? document.body : undefined
        }
      />
    </Container>
  );
};

export { StyledSelect };
